import React from 'react';
import { Typography } from '@mui/material';
import { HeaderFormContainer } from './Styled/AuthGroupCustom.styles';

interface Props {
  title: string;
}

export const HeaderForm: React.FC<Props> = ({ title }) => (
  <HeaderFormContainer>
    <Typography variant="h4">{title}</Typography>
  </HeaderFormContainer>
);
